import React from "react";
import Coupons from "../../components/dashboard/coupons";
import NextSteps from "../../components/dashboard/nextSteps";
import ImportantLinks from "../../components/dashboard/importantLinks";
import Feeds from "../../components/dashboard/feeds";
import CoachStats from "../../components/dashboard/coachStats";
import { useSelector } from 'react-redux';
// import ProgramCertificate from "../../components/dashboard/ProgramCertificate";
import ProgramCertificateNew from "../../components/dashboard/ProgramCertificateNew/ProgramCertificateNew";

const RightSidebar = () => {
    const loggedInUser = useSelector((state) => state.auth.loggedInUser);

    return (
        <div className="rightSection">

            {loggedInUser && loggedInUser.roleId === 5 && <CoachStats />}

            {loggedInUser && loggedInUser.roleId !== 5 && <ProgramCertificateNew />}

            {/* <NextSteps /> */}

            <ImportantLinks />

            {/* {loggedInUser && loggedInUser.roleId !== 5 && <Coupons />} */}

            {/*TODO-change-04.09.2024 */}            
            {/* <Feeds /> */}
            {/*TODO-change-04.09.2024 */}            

        </div>
    );
};

export default RightSidebar;